import {
  validatePhoneNumber,
  validateEmail,
  validatePassword,
} from "./helpers";

const loginFields = (t) => [
  {
    label: t("Mobile Number"),
    name: "phoneNumber",
    placeholder: t("123456789"),
    typeKey: "phoneNumber",
    required: true,
    rules: [
      {
        validator: (_, value) => {
          return validatePhoneNumber(value, t);
        },
      },
    ],
  },
  {
    typeKey: "password",
    label: t("Password"),
    name: "password",
    placeholder: t("Enter your password"),
    type: "password",
    autoComplete: "current-password",
    required: true,
    rules: [
      {
        required: true,
        message: t("Please enter your password"),
      },
    ],
  },
];

const registerFields = (t) => [
  {
    label: t("Full Name"),
    placeholder: t("Enter your name"),
    name: "name",
    typeKey: "name",
    required: true,
    rules: [
      {
        required: true,
        message: t("Please enter your name"),
      },
    ],
  },
  {
    label: t("Email"),
    placeholder: t("Enter your email"),
    name: "email",
    typeKey: "email",
    required: true,
    rules: [
      {
        validator: (_, value) => {
          return validateEmail(value, t);
        },
      },
    ],
  },
  loginFields(t)[0],
  {
    typeKey: "password",
    label: t("Password"),
    name: "password",
    placeholder: t("Enter your password"),
    type: "password",
    required: true,
    rules: [
      {
        validator: (_, value) => {
          return validatePassword(value, t);
        },
      },
    ],
  },
];

const resetPasswordFields = (t, form) => {
  return [
    {
      typeKey: "password",
      label: t("Password"),
      name: "password",
      placeholder: t("Enter your password"),
      type: "password",
      required: true,
      rules: [
        {
          validator: (_, value) => validatePassword(value, t),
        },
      ],
    },
    {
      typeKey: "confirmPassword",
      label: t("Confirm Password"),
      name: "confirmPassword",
      placeholder: t("Confirm your password"),
      type: "password",
      required: true,
      rules: [
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.reject(t("Confirm password is required"));
            }

            const password = form.getFieldValue("password");

            if (value !== password) {
              return Promise.reject(t("Passwords do not match"));
            }

            return Promise.resolve();
          },
        },
      ],
    },
    {
      typeKey: "code",
      label: t("Code"),
      name: "code",
      placeholder: t("Enter the code"),
      type: "text",
      required: true,
      rules: [
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.reject(t("Code is required"));
            }
            return Promise.resolve();
          },
        },
      ],
    },
  ];
};

export { loginFields, registerFields, resetPasswordFields };
